import styled from 'styled-components';

export const Base = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	margin-left: 4px;
`;

export const Swatch = styled.button<{ $color: string; $disabled?: boolean }>`
	width: 24px;
	height: 24px;
	border-radius: 50%;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ $color }) => $color};
	padding: 0;
	flex-shrink: 0;
	outline: none;
	transition: border-color 0.15s ease, box-shadow 0.15s ease;
	opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

	&:hover {
		border-color: ${({ theme, $disabled }) => ($disabled ? theme.gray[200] : theme.gray[400])};
		box-shadow: ${({ $disabled, theme }) =>
			$disabled ? 'none' : `0 0 0 2px ${theme.gray[100]}`};
	}

	&:focus-visible {
		border-color: ${({ theme, $disabled }) => ($disabled ? theme.gray[200] : theme.blue[500])};
		box-shadow: ${({ $disabled, theme }) =>
			$disabled ? 'none' : `0 0 0 2px ${theme.blue[300]}`};
	}
`;

export const Dropdown = styled.div<{ $top: number; $right: number }>`
	position: fixed;
	top: ${({ $top }) => $top}px;
	right: ${({ $right }) => $right}px;
	left: auto;
	width: max-content;
	max-width: 90vw;
	background: ${({ theme }) => theme.gray[0]};
	border-radius: 8px;
	padding: 4px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	border: 1px solid ${({ theme }) => theme.gray[200]};
	z-index: 1000;
`;

export const Option = styled.div<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 12px;
	border-radius: 6px;
	font-size: 14px;
	font-family: 'Inter', sans-serif;
	font-weight: 400;
	color: ${({ theme }) => theme.gray[1000]};
	background: ${({ $active, theme }) => ($active ? theme.gray[100] : 'transparent')};
	transition: background-color 0.1s ease;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const OptionSwatch = styled.div<{ $color: string }>`
	width: 16px;
	height: 16px;
	border-radius: 50%;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ $color }) => $color};
	flex-shrink: 0;
`;
